// ==================================================================================================
//
// Form Custom Select
//
// ==================================================================================================
const formCustomSelect = () => {
  let props = {};
  let els = {};

  // Cache dom element selectors
  // ------------------------------------------------
  const createChildren = () => {
    els.$select = $('.js-custom-select');
  }

  // Run selectboxit
  // ------------------------------------------------
  const enableSelect = (e) => {
    if (!els.$select.parent().hasClass('select-container--member-goal')) els.$select.parent().addClass('form__custom-select--standard')
    els.$select.show().removeClass('is-hidden')
  }

  // Change color of select after selected to make clear
  // the field has been completed
  // ------------------------------------------------
  const changeSelectColor = (e) => {
    if (window.CrunchMemberPortal.isMobileDevice) {
      let $thisSelect = $(e.target)
      $thisSelect.css('color', 'rgba(0, 0, 0, 1)');
    } else {
      $(e.target).removeClass('parsley-error')
      $(e.target).parents('.select-container').siblings('.form__input-label-group').find('.parsley-errors-list').remove()
    }
  }

  // Enable
  // ------------------------------------------------
  const enable = () => {
    if (props.isEnabled) return;

    // Remove container if it already exists so it can be re-added and re-initted
    if($('.selectboxit-container').length !== 0) $('.selectboxit-container').remove();

    // Add your event handlers here
    enableSelect()
    els.$select.on('change', changeSelectColor)

    props.isEnabled = true;
  }

  // Disable
  // ------------------------------------------------
  const disable = () => {
    if (!props.isEnabled) return;

    // Remove your event handlers here
    els.$select.off('change', changeSelectColor)

    props.isEnabled = false;
  }

  // Init
  // ------------------------------------------------
  const init = () => {
    createChildren();
    enable();
  }

  return {
    init,
    enable,
    disable
  };
}

export default formCustomSelect;
